import { LOG_OUT } from "../../../auth/actions/actions-types";
import { ActionTypes, type ActionReturns } from "./activeCourse.actions";
import { initialState, type State } from "./activeCourse.state";

export const defaultReducer = (
  state: State = initialState,
  action: ActionReturns
): State => {
  switch (action.type) {
    case ActionTypes.SET_ACTIVE_COURSE: {
      return action.payload.courseId;
    }
    case LOG_OUT: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
